export default __webpack_public_path__ + "static/media/slide-image2.28720b42.png";